import { IActivityHistoryGroup } from "../../../domain/model";
import { GROUP_BASE_HEIGHT, GROUP_ITEM_HEIGHT, GROUP_SUBGROUP_HEADER_HEIGHT } from "./constants";

// Deterministic, content-based height estimate for a group. It is a pure
// function of the group's item/subgroup counts, so it never mutates the
// virtualizer or schedules a render — unlike the adaptive running-average
// estimate that did and hung the app. Scaling the estimate with item count
// keeps the virtualizer's offsets close to the real heights, which is what
// stops the scroll snapping back when you scroll up into groups that were
// never measured.
export const estimateGroupHeight = (group: IActivityHistoryGroup | undefined): number => {
  if (!group) return GROUP_BASE_HEIGHT;

  const directItems = group.items?.length ?? 0;
  const subGroups = group.subGroups ?? [];
  const subGroupItems = subGroups.reduce((total, subGroup) => total + (subGroup.items?.length ?? 0), 0);

  return GROUP_BASE_HEIGHT + (directItems + subGroupItems) * GROUP_ITEM_HEIGHT + subGroups.length * GROUP_SUBGROUP_HEADER_HEIGHT;
};
